<template>
  <div class="col-md-10 text-start home mt-4">
    <router-link class="nav-link mb-2" to="/orders">
      <i class="bi bi-arrow-left"></i> Go back
    </router-link>
    <div class="row">
      <div class="col-md-12 text-start">
        <h5 class="bold d-inline-block">Order details</h5>
        <span v-if="!isLoading && order" class="small"></span>
        <span v-else class="small">&nbsp;Loading...</span>
      </div>
    </div>

    <Loading :isLoading="isLoading" />

    <div v-if="!isLoading" class="row">
      <div class="col-md-12">
        <div class="card p-3">
          <div class="row">
            <div class="col-md-8">
              <b>{{ userStore.userInfo?.companyName }}</b>
            </div>
            <div class="col-md-2"><b>Order date:</b></div>
            <div class="col-md-2">
              {{ getFormattedOrderDate(order?.orderDate) }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 bold">
              <span v-if="order?.orderReference">Order reference:</span>
            </div>
            <div class="col-md-6 text-start">
              {{ order?.orderReference ? order?.orderReference : "" }}
            </div>
            <div class="col-md-2"><b>Order number:</b></div>
            <div class="col-md-2">
              {{ order?.orderNumber ? order.orderNumber : "Being processed" }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 bold">
              <span v-if="order?.message">Comment:</span>
            </div>
            <div class="col-md-6">
              {{ order?.orderReference ? order?.message : "" }}
            </div>
            <div class="col-md-2"><b>Order status:</b></div>
            <div class="col-md-2">
              {{ getOrderStatusText(order?.orderStatus) }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 bold">
              <span v-if="order?.deliveryAddress">Delivery Address:</span>
            </div>
            <div class="col-md-6" v-if="order?.deliveryAddress">
              <span v-if="order.deliveryAddress.addressStreet"
                ><strong>Street:</strong>
                {{ order.deliveryAddress.addressStreet }}</span
              >
              <span v-if="order.deliveryAddress.addressCity">
                | <strong>City:</strong>
                {{ order.deliveryAddress.addressCity }}</span
              >
              <span v-if="order.deliveryAddress.addressZipCode">
                | <strong>Zip Code:</strong>
                {{ order.deliveryAddress.addressZipCode }}</span
              >
              <span v-if="order.deliveryAddress.addressCountryRegionId">
                | <strong>Country:</strong>
                {{ order.deliveryAddress.addressCountryRegionId }}</span
              >
              <span v-if="order.deliveryAddress.addressDescription">
                | <strong>Description:</strong>
                {{ order.deliveryAddress.addressDescription }}</span
              >
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <hr />

              <table class="table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th class="text-end">Product number</th>
                    <th class="text-end">Quantity</th>
                    <th class="text-end">
                      {{
                        order?.orderId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Requested Shipping"
                          : "Requested Delivery"
                      }}
                    </th>
                    <th class="text-end">Price / box</th>
                    <th
                      v-if="
                        !order?.orderLines?.some(
                          (orderRow) => orderRow.itemDiscount === '0.0'
                        )
                      "
                      class="text-end"
                    >
                      Discount
                    </th>
                    <th class="text-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(ol, index) in order?.orderLines"
                    :key="index"
                  >
                    <tr>
                      <td class="bold">{{ ol.productName }}</td>
                      <td class="text-end">{{ ol?.productId }}</td>
                      <td class="text-end">
                        {{ formatAmount(ol?.quantity) }}
                      </td>
                      <td class="text-end">
                        {{
                          order?.orderId ===
                          "00000000-0000-0000-0000-000000000000"
                            ? getFormattedOrderDate(ol.requestedShippingDate)
                            : getFormattedOrderDate(ol.requestedDeliveryDate)
                        }}
                        <br />
                      </td>
                      <td class="text-end">
                        {{
                          formatCurrency(
                            ol?.itemPrice,
                            order?.currency
                              ? order?.currency
                              : userStore.userInfo?.currency
                          )
                        }}
                      </td>
                      <td
                        class="text-end"
                        v-if="
                          ol?.itemDiscount !== undefined &&
                          ol?.itemDiscount !== '0.0'
                        "
                      >
                        {{ ol.itemDiscount }} %
                      </td>

                      <td class="text-end">
                        {{
                          formatCurrency(
                            ol?.totalPrice,
                            order?.currency
                              ? order?.currency
                              : userStore.userInfo?.currency
                          )
                        }}
                      </td>
                    </tr>
                    <tr
                      v-if="
                        ol.artworkVersion_Box ||
                        ol.artworkVersion_Label ||
                        ol.artworkVersion_Leaflet ||
                        ol.artworkVersion_Sachet ||
                        ol.artworkVersion_ShipperLabel ||
                        ol.comment ||
                        ol.requestedDeliveryDate
                      "
                    >
                      <td colspan="7" class="pb-4">
                        <!-- Artwork -->
                        <div
                          v-if="
                            ol.artworkVersion_Box ||
                            ol.artworkVersion_Label ||
                            ol.artworkVersion_Leaflet ||
                            ol.artworkVersion_Sachet ||
                            ol.artworkVersion_ShipperLabel
                          "
                          class="row mb-1"
                        >
                          <div class="col-md-2 pt-2">Artwork version</div>
                          <div class="col-md-2" v-if="ol.artworkVersion_Box">
                            <!-- Box -->
                            <div class="input-group mb-3">
                              <span
                                class="input-group-text"
                                title="Artwork version box"
                                ><i
                                  class="bi bi-box"
                                  title="Artwork version box"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_Box
                              }}</label>
                            </div>
                          </div>

                          <div class="col-md-2" v-if="ol.artworkVersion_Label">
                            <!-- Label -->
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-tag"
                                  title="Artwork version label"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_Label
                              }}</label>
                            </div>
                          </div>
                          <div
                            class="col-md-2"
                            v-if="ol.artworkVersion_Leaflet"
                          >
                            <!-- Leaflet -->
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-card-list"
                                  title="Artwork version leaflet"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_Leaflet
                              }}</label>
                            </div>
                          </div>
                          <div class="col-md-2" v-if="ol.artworkVersion_Sachet">
                            <!-- Sachet -->
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-bag"
                                  title="Artwork version sachet"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_Sachet
                              }}</label>
                            </div>
                          </div>
                          <div
                            class="col-md-2"
                            v-if="ol.artworkVersion_ShipperLabel"
                          >
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-truck"
                                  title="Artwork version shipper label"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_ShipperLabel
                              }}</label>
                            </div>
                          </div>

                          <div
                            class="col-md-2"
                            v-if="ol.artworkVersion_Blister"
                          >
                            <!-- Leaflet -->
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-boxes"
                                  title="Artwork version blister"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_Blister
                              }}</label>
                            </div>
                          </div>

                          <div
                            class="col-md-2"
                            v-if="ol.artworkVersion_ShipperCarton"
                          >
                            <!-- Leaflet -->
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-box2"
                                  title="Artwork version shipper carton"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_ShipperCarton
                              }}</label>
                            </div>
                          </div>

                          <div
                            class="col-md-2"
                            v-if="ol.artworkVersion_PalletLabel"
                          >
                            <!-- Leaflet -->
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-layout-text-sidebar"
                                  title="Artwork version pallet carton"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_PalletLabel
                              }}</label>
                            </div>
                          </div>

                          <div
                            class="col-md-2"
                            v-if="ol.artworkVersion_WrapLabel"
                          >
                            <!-- Leaflet -->
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-journal-text"
                                  title="Artwork version Wrap Label"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_WrapLabel
                              }}</label>
                            </div>
                          </div>

                          <div
                            class="col-md-2"
                            v-if="ol.artworkVersion_WhiteboxLabel"
                          >
                            <!-- Leaflet -->
                            <div class="input-group mb-3">
                              <span class="input-group-text"
                                ><i
                                  class="bi bi-justify-left"
                                  title="Artwork version White Box Label"
                                ></i
                              ></span>
                              <label class="py-2 px-2">{{
                                ol.artworkVersion_WhiteboxLabel
                              }}</label>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="ol.comment || ol.requestedDeliveryDate"
                          class="row"
                        >
                          <div v-if="ol.comment" class="col-md-6">
                            Comment: {{ ol.comment }}
                          </div>
                          <div v-if="ol.requestedDeliveryDate" class="col-md-6">
                            Requested date:
                            {{
                              getFormattedOrderDate(ol.requestedDeliveryDate)
                            }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <tr>
                    <td colspan="7" class="text-end">
                      <table class="float-end total-table">
                        <tbody>
                          <tr
                            v-if="
                              order?.totalDiscount != undefined &&
                              order?.totalDiscount > 0
                            "
                          >
                            <td class="p-1"><b>Discount:&nbsp;&nbsp;</b></td>
                            <td class="p-1">-{{ order?.totalDiscount }}</td>
                          </tr>
                          <tr>
                            <td class="p-1"><b>Subtotal:&nbsp;&nbsp;</b></td>
                            <td class="p-1">
                              {{
                                formatCurrency(
                                  order?.subTotal,
                                  order?.currency
                                    ? order?.currency
                                    : userStore.userInfo?.currency
                                )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { useUserStore } from "@/store/userStore";
import { OrderClient, OrdersInfo, GetOrderRequest } from "@/data/client";
import { useOrdersStore } from "@/store/ordersStore";
import { formatCurrency, formatAmount, formatDate } from "@/helpers/HelperTool";
import Loading from "@/components/shared/Loading.vue";
import axios, { Axios } from "axios";
import { msalInstance } from "@/config/msalConfig";
import { msalService } from "@/config/useAuth";

@Component({
  components: { Loading },
})
class OrderDetailsView extends Vue {
  userStore = useUserStore();
  ordersStore = useOrdersStore();
  orderClient!: OrderClient;
  orderNumber: string | undefined;
  order: OrdersInfo | undefined;
  isLoading = true;

  async mounted() {
    var axiosClient = axios.create();
    await this.initialize(axiosClient);
    this.orderClient = new OrderClient(
      process.env.VUE_APP_BACKEND_URI ?? "",
      axiosClient
    );

    this.orderNumber = this.$route.query.orderInfo?.toString();

    const req = new GetOrderRequest({
      orderNumber: this.orderNumber,
    });

    this.order = await this.orderClient.getOrder(req);
    this.isLoading = false;
  }

  async initialize(axiosClient: Axios) {
    try {
      await msalInstance.initialize();
      this.registerAuthorizationHeaderInterceptor(axiosClient);
    } catch (error) {
      console.log("Initialization error", error);
    }
  }

  registerAuthorizationHeaderInterceptor =
    msalService().registerAuthorizationHeaderInterceptor;

  formatCurrency(
    value: number | undefined,
    currency: string | undefined = "USD"
  ): string {
    return formatCurrency(value, currency);
  }

  formatAmount(value: number | undefined): string {
    return formatAmount(value);
  }

  getOrderStatusText(status: number | undefined): string {
    const statusMap: Record<number, string> = {
      1: "New",
      3: "In Process",
      5: "Cancelled",
      6: "Invoiced",
      7: "On Hold",
      175660002: "Cancelled",
    };

    return status !== undefined ? statusMap[status] ?? "Unknown" : "No status";
  }

  getFormattedOrderDate(orderDate: Date | undefined): string {
    if (!orderDate) return "";
    return formatDate(orderDate);
  }
}
export default OrderDetailsView;
</script>
